import { gql } from '@parkchirp/api-client';

export const LIST_ZONES = gql`
  query listZones(
    $order: SortOrder
    $filters: [Filter]
    $limit: Int!
    $offset: Int!
  ) {
    listZones(
      order: $order
      filters: $filters
      limit: $limit
      offset: $offset
    ) {
      data {
        id
        name
        number
        facilityName
        facilityNumber
        hasActiveRateStructure
        cityName
      }
      total
    }
  }
`;

export const GET_ZONE = gql`
  query getZone($zoneId: String!, $category: [String]) {
    getZone(zoneId: $zoneId, category: $category) {
      id
      name
      number
      facilityName
      facilityNumber
      facilityId
      organizationId
      cityId
      hourlyZoneQRCodeId
      zoneFees {
        id
        feeId
        fee {
          id
          feeName
          active
          calculationType
          feesHistory {
            price
            startDate
            inactiveDate
            tax1
            tax2
            tax3
            tax4
            taxCalculation
            inputType
            taxTableTax1 {
              id
              name
              taxNumber
              taxTableRates {
                percentageOfNet
                effectiveDate
              }
            }
            taxTableTax2 {
              id
              name
              taxNumber
              taxTableRates {
                percentageOfNet
                effectiveDate
              }
            }
            taxTableTax3 {
              id
              name
              taxNumber
              taxTableRates {
                percentageOfNet
                effectiveDate
              }
            }
            taxTableTax4 {
              id
              name
              taxNumber
              taxTableRates {
                percentageOfNet
                effectiveDate
              }
            }
          }
          hourlyFee {
            id
          }
        }
      }
      zoneSettings {
        id
        maxDuration
        scanToPayDurationIncrement
      }
    }
  }
`;
